import { useState } from 'react';
import dayjs from 'dayjs';
import { useUser } from 'src/UserContext';
import { Trans, useTranslation } from 'react-i18next';
import { calcRemainDay, getTranslateName } from 'src/services/util';
import { postPaypalRefund, postImpRefund } from 'src/services/checkout';
import { PRODUCT_REGION } from 'src/constants/product';

export default function MyActivatedCard({ item }: { item: CheckoutUserProduct }): JSX.Element {
  const { t } = useTranslation();
  const { userInfo } = useUser();
  const [calcData] = useState(calcRemainDay(item.endDate));

  return (
    <div className="mt-3">
      <div className="min-h-40 relative border border-ice-blue rounded bg-white p-6 flex justify-between">
        <div className="pr-7">
          <div className="N_12_M text-bluey-purple flex">
            <div>
              <Trans
                i18nKey={`product/my/remain_${calcData.translateName}`}
                values={{
                  date: calcData.date,
                  time: calcData.time,
                }}
              ></Trans>
            </div>
            {/* <div className="w-4 flex justify-center items-center">
              <div className="oval-2"></div>
            </div> */}
            {/* <div>{t('product/my/coupon')}</div> */}
          </div>
          <div className="N_16_R text-black mt-5" style={{ wordBreak: 'keep-all' }}>
            {item[getTranslateName()]}
          </div>
          <div className="N_12_R text-brown-grey mt-1 break-words">
            <Trans i18nKey="product/my/service_period_date" values={{ date: dayjs(item.endDate).format(calcData.format) }}></Trans>
          </div>
          <div className="mt-2 flex flex-wrap items-center justify-start">
            <div className="N_12_R text-brown-grey flex-shrink-0">{t('product/my/payment_no')}</div>
            <div className="division mx-1.5"></div>
            <div className="N_12_R text-black">{item.displayPaymentId}</div>
          </div>
        </div>
        <div className="flex justify-center items-center">
          <div className="w-16 h-16 rounded-full bg-bluey-purple text-white N_12_R flex justify-center items-center text-center">
            {t('product/my/period_ing')}
          </div>
        </div>
        {/* {/localhost/gi.test(location.href) && /^(single)/gi.test(item.status) && ( */}
        {/(development|stage)/gi.test(process.env.NODE_ENV) && /^(single)/gi.test(item.status) && (
          <button
            className="absolute right-0 bottom-0 border border-bluey-purple text-white bg-bluey-purple N_14_R py-1 px-2 rounded-sm"
            onClick={() => {
              if (userInfo.country === PRODUCT_REGION.KR) {
                postImpRefund(item.paymentId)
                  .then((res) => {
                    alert('success');
                    console.log(res);
                    location.reload();
                  })
                  .catch((e) => {
                    alert('error');
                    console.error(e);
                  });
              } else {
                postPaypalRefund(item.paymentId)
                  .then((res) => {
                    alert('success');
                    console.log(res);
                    location.reload();
                  })
                  .catch((e) => {
                    alert('error');
                    console.error(e);
                  });
              }
            }}
          >
            (임시)해지
          </button>
        )}
      </div>
    </div>
  );
}
